import React, { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

const DashboardPage = lazy(() => import('./dashboard/dashboard.page'));

export const dashboardRoutes: RouteObject = {
  element: <DashboardPage />,
  index: true,
};
